import { ViewPhotoState } from '@/enums/viewEnums.ts';
import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useWebSocketStore } from '@/store/useWebSocketStore.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

export const handlePhotoApproved = (ctxData: WebSocketMessage) => {
  const { setLastEvents } = useWebSocketStore.getState();
  const { updatePhoto } = useProfileStore.getState();

  if (ctxData.photo_approved_event?.photo_hid) {
    updatePhoto(ctxData.photo_approved_event.photo_hid, ViewPhotoState.APPROVE);
    setLastEvents({
      photoStateChange: { photo_hid: ctxData.photo_approved_event.photo_hid }
    });
  }
};
